export default __webpack_public_path__ + "static/icon-46bc3a40d45f85384715cece83213bfb.png";